var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useState, } from 'react';
// ******* CONTEXT ******
export var EditDeliveryAddressContext = createContext(undefined);
// ******* PROVIDER ******
export var EditDeliveryAddressProvider = function (_a) {
    var children = _a.children;
    var _b = useState({
        firstNameValue: '',
        lastNameValue: '',
        streetAddressValue: '',
        addressLineTwoValue: null,
        zipCodeValue: '',
        cityStateValue: '',
        phoneNumberValue: '',
    }), formState = _b[0], setFormState = _b[1];
    var _c = useState(null), deliveryInstructions = _c[0], setDeliveryInstructions = _c[1];
    var _d = useState([]), deliveryAddresses = _d[0], setDeliveryAddresses = _d[1];
    var _e = useState(false), showCalendar = _e[0], setShowCalendar = _e[1];
    var _f = useState(false), requireSignature = _f[0], setRequireSignature = _f[1];
    var _g = useState(null), availableDeliverySlotsResponse = _g[0], setAvailableDeliverySlotsResponse = _g[1];
    var _h = useState(null), selectedDateId = _h[0], setSelectedDateId = _h[1];
    var _j = useState([]), availableDeliverySlots = _j[0], setAvailableDeliverySlots = _j[1];
    var _k = useState(''), deliveryDate = _k[0], setDeliveryDate = _k[1];
    var _l = useState(null), selectedDeliverySlot = _l[0], setSelectedDeliverySlot = _l[1];
    var _m = useState(false), isEligibilityChecked = _m[0], setIsEligibilityChecked = _m[1];
    var _o = useState(false), isEligible = _o[0], setIsEligible = _o[1];
    var _p = useState(''), selectedAddressId = _p[0], setSelectedAddressId = _p[1];
    var updateFormField = function (fields) {
        setFormState(function (prev) { return (__assign(__assign({}, prev), fields)); });
    };
    return (React.createElement(EditDeliveryAddressContext.Provider, { value: {
            formState: formState,
            updateFormField: updateFormField,
            deliveryAddresses: deliveryAddresses,
            setDeliveryAddresses: setDeliveryAddresses,
            deliveryInstructions: deliveryInstructions,
            setDeliveryInstructions: setDeliveryInstructions,
            showCalendar: showCalendar,
            setShowCalendar: setShowCalendar,
            requireSignature: requireSignature,
            setRequireSignature: setRequireSignature,
            availableDeliverySlots: availableDeliverySlots,
            setAvailableDeliverySlots: setAvailableDeliverySlots,
            availableDeliverySlotsResponse: availableDeliverySlotsResponse,
            setAvailableDeliverySlotsResponse: setAvailableDeliverySlotsResponse,
            selectedDateId: selectedDateId,
            setSelectedDateId: setSelectedDateId,
            deliveryDate: deliveryDate,
            setDeliveryDate: setDeliveryDate,
            selectedDeliverySlot: selectedDeliverySlot,
            setSelectedDeliverySlot: setSelectedDeliverySlot,
            isEligibilityChecked: isEligibilityChecked,
            setIsEligibilityChecked: setIsEligibilityChecked,
            isEligible: isEligible,
            setIsEligible: setIsEligible,
            selectedAddressId: selectedAddressId,
            setSelectedAddressId: setSelectedAddressId,
        } }, children));
};
